import React from 'react';
import { Chip } from '@mui/material';
import {
    DataGridPro,
    GridActionsCellItem,
} from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinearProgress from '@mui/material/LinearProgress';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ColumnsFilterExportToolbar } from 'Components/DataGrid/Toolbars';
import moment from 'moment';
import { CountryCodeMap } from 'Services/CountryService';

export default function BundleGridView({ isLoading, bundleList, onBundleSelected, onArchiveBundle }) {
    const columns = [
        {
            field: 'statusCode',
            headerName: 'Status',
            width: 200,
            editable: false,
            renderCell: (params) => {
                return <Chip label={params.value} />;
            },
        },
        {
            field: 'id',
            headerName: 'Bundle Id',
            width: 150,
            editable: false,
            renderCell: (params) => {
                return <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{params.value}</span>;
            },
        },
        {
            field: 'bundleName',
            headerName: 'Bundle Title',
            flex: 1,
            renderCell: (params) => {
                return <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{params.value}</span>;
            },
        },
        {
            field: 'bundleType',
            headerName: 'Category',
            width: 100,
            editable: false,
            renderCell: (params) => {
                return <Chip label={params.value} />;
            },
        },
        {
            field: 'connections',
            headerName: 'Connection',
            editable: false,
            flex: 1,
            valueGetter: (params) => {
                return params.row.heroProduct?.name || '-';
            },
        },
        {
            field: 'countryList',
            headerName: 'Location',
            editable: false,
            flex: 1,
            valueFormatter: params => params?.value?.map(c => CountryCodeMap[c] || c) || '-'
        },
        {
            field: 'createdDateTime',
            headerName: 'Created',
            editable: false,
            flex: 1,
            valueFormatter: (params) => {
                return moment(params.value).format('YYYY-MM-DDThh:mm')
            }
        },
        {
            field: 'updatedDateTime',
            headerName: 'Updated',
            editable: false,
            flex: 1,
            valueFormatter: (params) => {
                return moment(params.value).format('YYYY-MM-DDThh:mm')
            }
        },

        {
            field: 'actions',
            type: 'actions',
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<RemoveRedEyeIcon />}
                    onClick={() => previewBundle(params.row)}
                    label="Preview"
                />,
                <GridActionsCellItem
                    icon={<EditIcon />}
                    onClick={() => onBundleSelected(params.row.id)}
                    label="Edit"
                    showInMenu
                />,
                <GridActionsCellItem
                    icon={<DeleteIcon />}
                    onClick={() => onArchiveBundle(params.row)}
                    label="Archive"
                    showInMenu
                />,
            ],
        },
    ];

    function previewBundle(bundle) {
        window.open('https://www.amazingco.me/');
    }

    function handleCellClick(params) {
        if (params.field === 'id' || params.field === 'bundleName') {
            onBundleSelected(params.row.id);
        }
    }

    return (
        <DataGridPro
            onCellClick={handleCellClick}
            disableSelectionOnClick
            loading={isLoading}
            columns={columns}
            pagination={true}
            pageSize={10}
            components={{ Toolbar: ColumnsFilterExportToolbar, LoadingOverlay: LinearProgress }}
            style={{ flex: 1 }}
            rows={bundleList}
            sx={{
                height: '800px',
                '.MuiDataGrid-columnHeaders': {
                    fontWeight: 'bold',
                    fontSize: 14,
                    color: 'rgb(0,0,0)',
                    backgroundColor: 'rgb(244,246,248)',
                },
                '.MuiTablePagination-selectLabel': {
                    marginBottom: '0px',
                },
                '.MuiTablePagination-displayedRows': {
                    marginBottom: '0px',
                },
                '.MuiPaper-root.div.span': {
                    color: 'blue',
                },
            }}
        />
    );
}
